"use strict";

import angular from "angular";

import template from "./file-import.component.html";
import "./themes/file-import.component.scss";

import { SourceConvert } from "../../../presentation/services/SourceConvert/SourceConvert";

class FileImportComponent {
    constructor($scope) {
        this.$scope = $scope;

        this.files = [];
        this.currentFileError = null;
        this.currentFileErrorIndex = null;
    }

    $onInit() {
        this.sourceHuman = SourceConvert.toHuman(this.viewConfigs.source);
    }

    $onChanges(changes) {}

    onDropFiles(files) {
        this.files = files;

        this.onSetFiles({ files });
    }

    onStartImport(event) {
        this.onImportData({ event, files: this.files });
    }

    async onSave() {
        this.loading = true;
        await this.onSaveList();
        this.loading = false;
        this.files = [];
    }

    onCancel() {
        this.importingList = [];
        this.viewConfigs.step = 0;
        this.files = [];

        this.onCancelList();
    }

    onSelectAction(type) {
        this.onCancel();
        this.onClickAction({ type });
    }

    onRemoveFile(index) {
        this.files.splice(index, 1);
    }

    onErrorButtonClick() {
        this.onCancel();
    }

    togglePopover(popoverInfo) {
        if (!popoverInfo) return;

        this.togglePopOverInfo = !this.togglePopOverInfo;

        this.$scope.$applyAsync();
    }

    onErrorClick(file, index) {
        this.currentFileError = file;
        this.viewConfigs.step = 4;
        this.currentFileErrorIndex = index;
        this.$scope.$applyAsync();
    }

    onReturnStep() {
        this.viewConfigs.step = 1;
        this.currentFileError = null;
        this.currentFileErrorIndex = null;
        this.$scope.$applyAsync();
    }

    onRemoveFileInconsistency() {
        this.handleRemoveFileInconsistency({
            file: this.currentFileError,
            index: this.currentFileErrorIndex
        });
    }

    onImportFileInconsistency() {
        this.handleImportFileInconsistency({
            file: this.currentFileError,
            index: this.currentFileErrorIndex
        });
    }
}

FileImportComponent.$inject = ["$scope"];

const name = "fileImportComponent";
const def = {
    bindings: {
        viewConfigs: "<",
        currentYear: "=",
        onSetFiles: "&",
        dropOptions: "<",
        onImportData: "&",
        step: "=",
        importingList: "<",
        onSaveList: "&",
        onCancelList: "&",
        onClickHint: "&",
        onChangeYear: "&",
        handleRemoveFileInconsistency: "&",
        handleImportFileInconsistency: "&",
        loading: "=",
        successActions: "<",
        onClickAction: "&",
        onClickContractHint: "&",
        hasPermissionCompanyModel: "<"
    },
    controller: FileImportComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
